var OutgoingMessageStates = /*#__PURE__*/function (OutgoingMessageStates) {
  OutgoingMessageStates["NONE"] = "NONE";
  OutgoingMessageStates["PENDING"] = "PENDING";
  OutgoingMessageStates["SENT"] = "SENT";
  OutgoingMessageStates["FAILED"] = "FAILED";
  OutgoingMessageStates["DELIVERED"] = "DELIVERED";
  OutgoingMessageStates["READ"] = "READ";
  return OutgoingMessageStates;
}({});
var getOutgoingMessageState = function getOutgoingMessageState(channel, message) {
  var _channel$isGroupChann;
  if (message.sendingStatus === 'pending') {
    return OutgoingMessageStates.PENDING;
  }
  if (message.sendingStatus === 'failed') {
    return OutgoingMessageStates.FAILED;
  }
  if (channel !== null && channel !== void 0 && (_channel$isGroupChann = channel.isGroupChannel) !== null && _channel$isGroupChann !== void 0 && _channel$isGroupChann.call(channel)) {
    var _getUnreadMemberCount, _ref, _getUndeliveredMember, _ref2;
    /* GroupChannel only */
    if (((_getUnreadMemberCount = (_ref = channel).getUnreadMemberCount) === null || _getUnreadMemberCount === void 0 ? void 0 : _getUnreadMemberCount.call(_ref, message)) === 0) {
      return OutgoingMessageStates.READ;
    } else if (((_getUndeliveredMember = (_ref2 = channel).getUndeliveredMemberCount) === null || _getUndeliveredMember === void 0 ? void 0 : _getUndeliveredMember.call(_ref2, message)) === 0) {
      return OutgoingMessageStates.DELIVERED;
    }
  }
  if (message.sendingStatus === 'succeeded') {
    return OutgoingMessageStates.SENT;
  }
  return OutgoingMessageStates.NONE;
};
export { OutgoingMessageStates, getOutgoingMessageState };